<mat-icon
  class="declined-icon"
  matTooltipPosition="right"
  (click)="openDialog($event)">
  info_outline
</mat-icon>
